import { put, select, takeLatest } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddDrainToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/drain/store/drain.actions'
import { addDrainItem } from '../../timeline/store/timeline.actions'
import { DrainConstants } from '../../procedures/drain/store/drain.constants'

export function* saveDrainQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addDrainToTimeline } = quickActionsObject
  if (addDrainToTimeline) {
    yield put(addDrainItem())
    yield put(setAddDrainToTimeline(false))
    yield put(resetState())
  }
}

export function* saveDrainQuickActionTimeLineRowSaga() {
  yield takeLatest([DrainConstants.SET_ADD_TO_TIMELINE], saveDrainQuickActionTimeLineRow)
}
